import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Avatar,
  Container,
} from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { verifyOtp } from "../api/axios";

export default function VerifyOtp() {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const handleVerify = async () => {
    if (!otp) return setError("OTP is required.");
    try {
      await verifyOtp( email, otp );
      toast.success("OTP verified.");
      navigate("/reset-password", { state: { email, otp } });
    } catch (err) {
      const msg = err.response?.data?.error || "Invalid OTP.";
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #6E8EF8, #A5DCF8)", p: 2 }}>
      <Container maxWidth="xs">
        <Paper elevation={6} sx={{ p: 4, borderRadius: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
            <Avatar sx={{ bgcolor: "primary.main", mb: 1 }}>
              <LockOutlined />
            </Avatar>
            <Typography variant="h5">Verify OTP</Typography>
          </Box>

          {error && (
            <Typography variant="body2" color="error" mb={1}>
              {error}
            </Typography>
          )}

          <TextField
            fullWidth
            label="Enter OTP"
            variant="outlined"
            margin="normal"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />

          <Button fullWidth variant="contained" sx={{ mt: 2 }} onClick={handleVerify}>
            Verify OTP
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
